import type { FC } from 'react';

import CapabilitiesSection from '@/features/home/components/CapabilitiesSection';
import ContactSection from '@/features/home/components/ContactSection';
import DownloadCta from '@/features/home/components/DownloadCta';
import FaqSection from '@/features/home/components/FaqSection';
import HeroSection from '@/features/home/components/HeroSection';
import HowItWorksSection from '@/features/home/components/HowItWorksSection';
import MoneySection from '@/features/home/components/MoneySection';
import ProblemSection from '@/features/home/components/ProblemSection';
import RentCategoriesSection from '@/features/home/components/RentCategoriesSection';
import TrustSection from '@/features/home/components/TrustSection';
import WhySection from '@/features/home/components/WhySection';
import { useHomePage } from '@/features/home/hooks/useHomePage.hook';

const HomePage: FC = () => {
  const {
    heroEyebrow,
    heroHeadline,
    heroCopy,
    phoneScreens,
    activeScreenId,
    onSelectScreen,
    storeBadges,
    problemHeadline,
    problemCards,
    whyShoutt,
    whyUsPoints,
    capabilityIntro,
    capabilityCards,
    rentIntro,
    rentCategories,
    rentNotes,
    steps,
    trustIntro,
    trustPoints,
    moneyPanels,
    faqItems,
    openFaqIndex,
    onToggleFaq,
    downloadCopy,
    contactTiles,
  } = useHomePage();

  return (
    /* The design's body rule — 15px/1.55. It sets the inherited size every
       `ch` measure on the page resolves against, so it has to live here
       rather than on each section. */
    <div className="text-[15px] leading-[1.55]">
      <HeroSection
        eyebrow={heroEyebrow}
        headline={heroHeadline}
        copy={heroCopy}
        screens={phoneScreens}
        activeScreenId={activeScreenId}
        onSelectScreen={onSelectScreen}
        badges={storeBadges}
      />
      <ProblemSection headline={problemHeadline} cards={problemCards} />
      <WhySection whyShoutt={whyShoutt} points={whyUsPoints} />
      <CapabilitiesSection intro={capabilityIntro} cards={capabilityCards} />
      <RentCategoriesSection intro={rentIntro} categories={rentCategories} notes={rentNotes} />
      <HowItWorksSection steps={steps} />
      <TrustSection intro={trustIntro} points={trustPoints} />
      <MoneySection panels={moneyPanels} />
      <FaqSection items={faqItems} openIndex={openFaqIndex} onToggle={onToggleFaq} />
      <DownloadCta copy={downloadCopy} badges={storeBadges} />
      <ContactSection tiles={contactTiles} />
    </div>
  );
};

export default HomePage;
